import { render, staticRenderFns } from "./ErpcDesk.vue?vue&type=template&id=68e8ab30&scoped=true&"
import script from "./ErpcDesk.vue?vue&type=script&lang=ts&"
export * from "./ErpcDesk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8ab30",
  null
  
)

export default component.exports